import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('TRASPASE', ['FORM', 'TABLE_PRODUCTS'])
